// client/src/components/stats/foldToPushBenchmarks.ts
//
// Benchmarks Nash para fold-to-push por stack del shover.
// Basado en tablas Nash de chipEV (ICM-neutral) para 6-max.
//
// Lógica: cuanto más corto el stack del shover, más wide es su rango de push,
// por lo tanto hero necesita llamar más frecuente (fold% más bajo).
//
//   ≤10bb  → shover pushea casi cualquier mano, hero llama ~45-60%
//   10-20bb → rango más tight, hero llama ~30-45%
//   20-30bb → solo premiums, hero llama ~20-35%
//   >30bb   → shove muy raro / no estándar, sin benchmark confiable

import { ShoverStackBin } from '../../utils/pokerStats/types';

export interface FoldToPushBenchmark {
  min: number; // fold % mínimo saludable
  max: number; // fold % máximo saludable
}

export const FOLD_TO_PUSH_BENCHMARKS: Partial<Record<ShoverStackBin, FoldToPushBenchmark>> = {
  micro: { min: 40, max: 55 }, // ≤10bb: call wide, fold ≤55%
  short: { min: 55, max: 70 }, // 10-20bb: fold más frecuente
  mid:   { min: 65, max: 80 }, // 20-30bb: solo premium calls
  // deep: sin benchmark — los shoves de >30bb son situacionales
};

export type FoldToPushStatus = 'ok' | 'warn' | 'critical';

export function evalFoldToPush(bin: ShoverStackBin, value: number): FoldToPushStatus {
  const r = FOLD_TO_PUSH_BENCHMARKS[bin];
  if (!r) return 'ok';
  if (value >= r.min && value <= r.max) return 'ok';
  const gap = value > r.max ? value - r.max : r.min - value;
  const range = r.max - r.min || 10;
  return gap > range * 1.5 ? 'critical' : 'warn';
}

export function getFoldToPushBenchmark(bin: ShoverStackBin): FoldToPushBenchmark | null {
  return FOLD_TO_PUSH_BENCHMARKS[bin] || null;
}
